import loadsJs from 'loads-js';
import { BOOXI_ADA_LANGUAGES, BOOXI_ADA_URL, BOOXI_LANGUAGES, BOOXI_STANDARD_URL } from '../settings/booxi';

import { trackBooxi } from './gtm';
import { countryCode, language } from './translator';

let initialized = false;
const adaCountries = ['CA', 'US', 'INT'];

export default function () {
  if (useBooxiAda()) {
    loadsJs(BOOXI_ADA_URL);
  } else {
    loadsJs(BOOXI_STANDARD_URL);
  }
}

export function useBooxiAda() {
  return adaCountries.includes(countryCode);
}

export function booxiIsLoaded() {
  return (useBooxiAda() && window.BookNow) || window.booxiController;
}

export function getBooxiLanguage() {
  if (useBooxiAda()) {
    return BOOXI_ADA_LANGUAGES[language] || BOOXI_ADA_LANGUAGES.default;
  }
  return BOOXI_LANGUAGES[language] || BOOXI_LANGUAGES.default;
}

export function openBooxi(apiKeyBooxi) {
  const lang = getBooxiLanguage();
  const options = {
    apiKey: apiKeyBooxi,
    fontFamily: "'Century Gothic', Arial, sans-serif",
    language: lang,
    loadingAnimationUrl: "https://storage.googleapis.com/booxi-live-wp-storage/1/2021/01/booxi_loading_grey-square@2x.gif",
    primaryColor: "#000000",
    secondaryColor: "#aaaaaa",
    serviceTags: "appointment",
    uiStyle: "classic",
    useIframeOnMobile: true
  };

  if (useBooxiAda() && window.BookNow) {
    window.BookNow.open(options);
    trackBooxi();
  } else if (window.booxiController) {
    if (!initialized) {
      window.booxiController.configure(options);
      initialized = true;
    }
    window.booxiController.open(null, options);
    trackBooxi();
  }
}



// WEBPACK FOOTER //
// ./src/services/booxi.js